 import { Link } from 'react-router-dom';
 //import Header from "../Header";
//import Footer from "../Footer";
//import ChangePassword from "../ChangePassword";
// import Home from "../Pages/Home";
 // import ContactUs from "../Pages/ContactUs";
const homeMenu = ()=>{
	return (
	<ul className="nav nav-pills d-print-none">
  <li className="nav-item">
    <Link className="nav-link active" aria-current="page" to="/">Home</Link>
  </li>
  <li className="nav-item dropdown">
    <Link className="nav-link dropdown-toggle" data-bs-toggle="dropdown" to="#" role="button" aria-expanded="false">About</Link>
    <ul className="dropdown-menu">
      <li><Link className="dropdown-item" to="#">Products</Link></li>
      <li><Link className="dropdown-item" to="#">Gallery</Link></li>
      <li><Link className="dropdown-item" to="#">Achievements</Link></li>
      <li><hr className="dropdown-divider"/></li>
      <li><Link className="dropdown-item" to="/about">About Us</Link></li>
	  <li><Link className="dropdown-item" to="/cifcl_ta_letter">Print CIFCL TA Letter</Link></li>
    </ul>
  </li>
  <li className="nav-item">
    <Link className="nav-link" to="/ContactUs">Contact</Link>
  </li>

</ul>
	
	
	 );
}

export default homeMenu;